<template>
  <div class="screensaver" :class="{ active: screensaverStatus }">
    <div class="screensaver__video">
      <video muted loop playsinline preload="none">
        <source src="/static/video/screensaver_logo.mp4" type="video/mp4">
      </video>
    </div>
    <div class="marquee">
      <svg id="98daa4aa-1064-4e5a-ba10-a2e3700d0e91" data-name="Livello 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 318.61 135.29"><title>owof</title><g class="logo"><path d="M10,85.59a11.6,11.6,0,0,1-5.41-2.84,13.49,13.49,0,0,1-3.38-5.39A22.75,22.75,0,0,1,0,69.71a25.92,25.92,0,0,1,1.21-8.06,20.85,20.85,0,0,1,3.48-6.57,20.11,20.11,0,0,1,5.45-4.77,20.87,20.87,0,0,1,7.19-2.62,17.75,17.75,0,0,1,7.24.05A12,12,0,0,1,30,50.57a13.18,13.18,0,0,1,3.43,5.36,22.68,22.68,0,0,1,1.18,7.68,25.92,25.92,0,0,1-1.21,8.06,21.15,21.15,0,0,1-3.48,6.6A19.51,19.51,0,0,1,24.44,83a21.37,21.37,0,0,1-7.21,2.6,17.93,17.93,0,0,1-7.26,0M21,77.81A9.77,9.77,0,0,0,24,75a13.88,13.88,0,0,0,1.91-4.27A21.66,21.66,0,0,0,26.54,65a19.23,19.23,0,0,0-.68-5.48A9,9,0,0,0,24,56,6,6,0,0,0,21,54.21a8.73,8.73,0,0,0-3.74-.09,10.62,10.62,0,0,0-3.74,1.41,9.53,9.53,0,0,0-2.92,2.83,14.19,14.19,0,0,0-1.88,4.27,21.66,21.66,0,0,0-.68,5.67,19,19,0,0,0,.68,5.43,9.42,9.42,0,0,0,1.88,3.6,5.79,5.79,0,0,0,2.92,1.8,8.72,8.72,0,0,0,3.74.09A10.61,10.61,0,0,0,21,77.81" transform="translate(0 -0.34)" fill-rule="evenodd"/><path d="M49.42,42.76,62.26,61.49q.39.61.72,1.25t.58,1.13q.29.58.53,1.11l.19,0V40.13l7.09-1.25V75.32l-8.11,1.43-13.13-19q-.43-.65-.8-1.28t-.6-1.12a9.82,9.82,0,0,1-.48-1.12l-.19,0V79.43l-7.14,1.26V44.25Z" transform="translate(0 -0.34)" fill-rule="evenodd"/><polygon points="103.62 32.85 103.62 39.42 86.92 42.36 86.92 50.76 101.44 48.2 101.44 54.62 86.92 57.18 86.92 65.67 104.39 62.59 104.39 69.16 79.29 73.58 79.29 37.14 103.62 32.85" fill-rule="evenodd"/><polygon points="135.85 63.61 126.34 65.28 117.71 30.37 125.43 29.01 131.75 55.74 138.89 26.64 146.08 25.37 153.18 51.62 159.5 23 166.64 21.74 158.05 59.69 148.64 61.35 142.22 37.39 135.85 63.61" fill-rule="evenodd"/><path d="M180.13,55.59a11.6,11.6,0,0,1-5.41-2.84,13.49,13.49,0,0,1-3.38-5.39,22.74,22.74,0,0,1-1.18-7.66,25.92,25.92,0,0,1,1.21-8.06,20.85,20.85,0,0,1,3.48-6.57,20.11,20.11,0,0,1,5.45-4.77,20.87,20.87,0,0,1,7.19-2.62,17.75,17.75,0,0,1,7.24.05,12,12,0,0,1,5.43,2.83,13.18,13.18,0,0,1,3.43,5.36,22.7,22.7,0,0,1,1.18,7.68,25.92,25.92,0,0,1-1.21,8.06,21.15,21.15,0,0,1-3.48,6.6A19.51,19.51,0,0,1,194.61,53a21.38,21.38,0,0,1-7.21,2.6,17.94,17.94,0,0,1-7.26,0m11.05-7.79A9.78,9.78,0,0,0,194.13,45,13.88,13.88,0,0,0,196,40.7a21.64,21.64,0,0,0,.68-5.67,19.22,19.22,0,0,0-.68-5.48A9,9,0,0,0,194.13,26a6,6,0,0,0-2.94-1.77,8.73,8.73,0,0,0-3.74-.09,10.63,10.63,0,0,0-3.74,1.41,9.53,9.53,0,0,0-2.92,2.83,14.18,14.18,0,0,0-1.88,4.27,21.65,21.65,0,0,0-.68,5.67,19,19,0,0,0,.68,5.43,9.42,9.42,0,0,0,1.88,3.6,5.79,5.79,0,0,0,2.92,1.8,8.72,8.72,0,0,0,3.74.09,10.61,10.61,0,0,0,3.74-1.41" transform="translate(0 -0.34)" fill-rule="evenodd"/><path d="M218.76,36.16V49.33l-7.67,1.35V14.25l14.67-2.59q6.18-1.09,9.65,1.12t3.48,7.57a11.94,11.94,0,0,1-1.83,6.55,15.39,15.39,0,0,1-5,4.84v.1l8.25,13.7L231.84,47l-7.24-11.9Zm0-6.42,5.7-1a15.35,15.35,0,0,0,2.53-.66,6.64,6.64,0,0,0,2.08-1.19A5.54,5.54,0,0,0,230.49,25a6.5,6.5,0,0,0,.53-2.77,5.69,5.69,0,0,0-.51-2.61,3.3,3.3,0,0,0-1.4-1.44,4.72,4.72,0,0,0-2.15-.49,14.31,14.31,0,0,0-2.7.24l-5.5,1Z" transform="translate(0 -0.34)" fill-rule="evenodd"/><polygon points="253.37 6.45 253.37 36.23 269.97 33.3 269.97 39.96 245.69 44.24 245.69 7.8 253.37 6.45" fill-rule="evenodd"/><path d="M275.42,2.91,287.24.82A28,28,0,0,1,294.7.45a13.3,13.3,0,0,1,6.11,2,11.4,11.4,0,0,1,4.1,4.88,19.52,19.52,0,0,1,1.5,8.25,24.28,24.28,0,0,1-1.33,8.27,18.84,18.84,0,0,1-3.79,6.39,20.1,20.1,0,0,1-6,4.46,29.54,29.54,0,0,1-8,2.55l-11.82,2.08Zm16.51,26.58a10.42,10.42,0,0,0,3.52-2.58,11.05,11.05,0,0,0,2.22-4.08,19.9,19.9,0,0,0,.77-5.93,16.18,16.18,0,0,0-.72-5.23,7,7,0,0,0-2.15-3.24A6.8,6.8,0,0,0,292,7a16.4,16.4,0,0,0-4.8.22L283,8V31.63l4.2-.74A19.39,19.39,0,0,0,291.93,29.48Z" transform="translate(0 -0.34)" fill-rule="evenodd"/><path d="M312.92,36.28a6.91,6.91,0,0,0,1.16-3.75l-3.52.62V25.28l8.06-1.42v6.32a12.89,12.89,0,0,1-1.67,6.5,15,15,0,0,1-5.82,5.3l-1.59-2.57a13.56,13.56,0,0,0,3.38-3.13" transform="translate(0 -0.34)" fill-rule="evenodd"/><path d="M10,135.24a11.6,11.6,0,0,1-5.41-2.84A13.49,13.49,0,0,1,1.18,127,22.75,22.75,0,0,1,0,119.36a25.92,25.92,0,0,1,1.21-8.06,20.85,20.85,0,0,1,3.48-6.57A20.11,20.11,0,0,1,10.14,100a20.87,20.87,0,0,1,7.19-2.62,17.76,17.76,0,0,1,7.24.05A12,12,0,0,1,30,100.22a13.18,13.18,0,0,1,3.43,5.36,22.68,22.68,0,0,1,1.18,7.68,25.92,25.92,0,0,1-1.21,8.06,21.15,21.15,0,0,1-3.48,6.6,19.51,19.51,0,0,1-5.48,4.78,21.39,21.39,0,0,1-7.21,2.6,18,18,0,0,1-7.26,0M21,127.45A9.77,9.77,0,0,0,24,124.61a13.88,13.88,0,0,0,1.91-4.27,21.66,21.66,0,0,0,.68-5.67,19.24,19.24,0,0,0-.68-5.48A9,9,0,0,0,24,105.62,6,6,0,0,0,21,103.85a8.73,8.73,0,0,0-3.74-.09,10.63,10.63,0,0,0-3.74,1.41A9.53,9.53,0,0,0,10.62,108a14.19,14.19,0,0,0-1.88,4.27,21.66,21.66,0,0,0-.68,5.67,19,19,0,0,0,.68,5.43,9.42,9.42,0,0,0,1.88,3.6,5.79,5.79,0,0,0,2.92,1.8,8.72,8.72,0,0,0,3.74.09A10.61,10.61,0,0,0,21,127.45" transform="translate(0 -0.34)" fill-rule="evenodd"/><path d="M49.42,92.4l12.84,18.73q.39.61.72,1.25t.58,1.13q.29.58.53,1.11l.19,0V89.78l7.09-1.25V125l-8.11,1.43-13.13-19q-.43-.65-.8-1.28t-.6-1.12a9.82,9.82,0,0,1-.48-1.12l-.19,0v25.19l-7.14,1.26V93.9Z" transform="translate(0 -0.34)" fill-rule="evenodd"/><polygon points="103.62 82.5 103.62 89.06 86.92 92.01 86.92 100.4 101.44 97.84 101.44 104.26 86.92 106.82 86.92 115.32 104.39 112.24 104.39 118.8 79.29 123.22 79.29 86.79 103.62 82.5" fill-rule="evenodd"/><polygon points="143.91 81.96 128.18 84.73 128.18 94.19 141.5 91.84 141.5 98.26 128.18 100.61 128.18 114.61 120.5 115.96 120.5 79.52 143.91 75.39 143.91 81.96" fill-rule="evenodd"/><path d="M156.85,101.45,154,110.4l-7.48,1.32L159.31,73l9.27-1.63,12.84,34.17-7.82,1.38L170.75,99Zm11.78-8.35-3.09-8.63a17.6,17.6,0,0,1-.63-1.92q-.24-.92-.48-1.7T164,79.2l-.43.08q-.24.86-.43,1.77t-.48,1.87q-.24,1.06-.58,2.18L159,94.8Z" transform="translate(0 -0.34)" fill-rule="evenodd"/><path d="M194.71,102.74a11.47,11.47,0,0,1-5.43-2.71,12.75,12.75,0,0,1-3.38-5.29A23.12,23.12,0,0,1,184.74,87,25.55,25.55,0,0,1,186,79a22.1,22.1,0,0,1,3.5-6.67,20.26,20.26,0,0,1,5.45-4.89A20,20,0,0,1,202,64.77a18.73,18.73,0,0,1,5.91-.2,12.76,12.76,0,0,1,4.56,1.49,9.51,9.51,0,0,1,3.14,2.85,11.71,11.71,0,0,1,1.74,3.87L210,75.58a7.59,7.59,0,0,0-3-3.7,7,7,0,0,0-5-.68,10,10,0,0,0-6.64,4.31q-2.53,3.58-2.53,9.76a18.8,18.8,0,0,0,.7,5.5,9.42,9.42,0,0,0,1.93,3.62,6.17,6.17,0,0,0,2.9,1.83,8,8,0,0,0,3.64.13,9.86,9.86,0,0,0,5.67-3A9.83,9.83,0,0,0,209.26,91a13.29,13.29,0,0,0,1-2.58l7.63.15A20,20,0,0,1,216.16,93a16.74,16.74,0,0,1-3.09,4.19,19.28,19.28,0,0,1-4.66,3.38,21.77,21.77,0,0,1-6.44,2.1,18.94,18.94,0,0,1-7.26,0" transform="translate(0 -0.34)" fill-rule="evenodd"/><polygon points="247.62 57.11 247.62 63.67 230.92 66.61 230.92 75.01 245.45 72.45 245.45 78.87 230.92 81.43 230.92 89.92 248.4 86.84 248.4 93.41 223.3 97.83 223.3 61.4 247.62 57.11" fill-rule="evenodd"/><polygon points="261.81 83.18 261.81 91.04 253.75 92.46 253.75 84.6 261.81 83.18" fill-rule="evenodd"/></g></svg>
    </div>
    <p class="disclaimer" v-if="isMobile()">(Catch me if you can)</p>
  </div>
</template>
<script>
import Marquee from '@/scripts/marquee';

import { qs, isMobile } from '@/scripts/utils';


export default {
  name: 'ScreenSaver',
  data() {
    return {
      timeoutID: null,
      marquee: null,

      screensaverStatus: false,

      screensaverTime: 120000,

      textColor: [
        '#fddfab',
        '#f2c699',
        '#d6b081',
        '#d0a972',
        '#d29b62',
        '#c18c60',
        '#b98458',
        '#ad784e',
        '#a26d41',
        '#955f39',
        '#8a5536',
        '#8a5536',
        '#804e35',
        '#6c472d',
        '#63432c',
        '#573728',
        '#402c23',
      ],

      isMobile,
    };
  },

  mounted() {
    this.screensaver();
  },

  methods: {
    screensaver() {
      document.body.addEventListener('mousemove', this.resetTimer, false);
      document.body.addEventListener('mousedown', this.resetTimer, false);
      document.body.addEventListener('keypress', this.resetTimer, false);
      document.body.addEventListener('DOMMouseScroll', this.resetTimer, false);
      document.body.addEventListener('touchmove', this.resetTimer, { passive: true });
      document.body.addEventListener('MSPointerMove', this.resetTimer, false);
      this.startTimer();
    },

    startTimer() {
      this.timeoutID = window.setTimeout(this.goInactive, this.screensaverTime);
    },

    resetTimer() {
      window.clearTimeout(this.timeoutID);
      if (this.screensaverStatus) this.goActive();
      this.startTimer();
    },

    goInactive() {
      this.screensaverStatus = true;

      this.marquee = new Marquee(qs('.marquee', this.$el), this.textColor);
      this.marquee.init();

      qs('video', this.$el).play();

      if (isMobile()) {
        window.addEventListener('deviceorientation', (event) => {
          if (event.gamma || event.beta) {
            const xGamma = event.gamma * 0.5 || 0;
            const yBeta = event.beta * 0.5 || 0;

            qs('video', this.$el).style.transform = `translate3d(${xGamma}px, -${yBeta}px, 0)`;
            qs('video', this.$el).style.webkitTransform = `translate3d(${xGamma}px, -${yBeta}px, 0)`;
          }
        });
      }
    },

    goActive() {
      this.$el.classList.remove('active');
      this.marquee.destroy();
      this.screensaverStatus = false;
      qs('video', this.$el).pause(0);
    },
  },

  beforeDestroy() {
    document.body.removeEventListener('mousemove', this.resetTimer);
    document.body.removeEventListener('mousedown', this.resetTimer);
    document.body.removeEventListener('keypress', this.resetTimer);
    document.body.removeEventListener('DOMMouseScroll', this.resetTimer);
    document.body.removeEventListener('touchmove', this.resetTimer);
    document.body.removeEventListener('MSPointerMove', this.resetTimer);
  },
};
</script>
<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

.screensaver {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 800;
  background: #000000;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  transition: all 200ms ease-out 0ms;

  &.active {
    visibility: visible;
    opacity: 1;
    transition: opacity 200ms ease-out 200ms;
  }

  .marquee {
    position: absolute;
    display: block;
    z-index: 10;
  }

  &__video {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    max-width: 60%;
    z-index: 0;
    mix-blend-mode: screen;

    video {
      position: relative;
      display: block;
      width: 100%;
    }

    @include mq(sm) {
      max-width: 540px;
    }
  }

  svg {
    display: block;
    width: 200px;

    .logo {
      fill: $color-blue;
    }

    @include mq(sm) {
      width: 300px;
    }
  }

  .disclaimer {
    color: $color-light;
    position: absolute;
    bottom: 40px;
    text-align: center;
    pointer-events: none;
    width: 100%;
    z-index: 0;
    padding: 5px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ScreenSaver.vue